'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import ChartCardLoading from '@/components/charts/components/ChartCardLoading';
const VaultYourPositionChartLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ChartCardLoading className="gap-lg" chartClassName="h-[224px]" valueClassName="h-[44px] w-[170px]" controls={["h-8 w-[76px] md:h-8 md:w-[99px]", "h-8 w-[103px]"]} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultYourPositionChartLoading);